import React from 'react';
import './Textarea.css';

const Textarea = ({
  label,
  value,
  onChange,
  placeholder = '',
  required = false,
  error = null,
  minLength = null,
  maxLength = null,
  rows = 4,
  showCounter = false
}) => {
  return (
    <div className="textarea">
      {label && (
        <label className="textarea__label">
          {label}
          {required && <span className="textarea__required">*</span>}
        </label>
      )}
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        className={`textarea__field ${error ? 'textarea__field--error' : ''}`}
      />
      <div className="textarea__footer">
        {error && <span className="textarea__error">{error}</span>}
        {showCounter && maxLength && (
          <span className="textarea__counter">
            {value.length} / {maxLength}
          </span>
        )}
      </div>
    </div>
  );
};

export default Textarea;
